import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.canvas.panel');
import { OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrich-canvas-panel',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichCanvasPanelComponent implements OnInit, OnChanges {
    @Input() documentId: string = '';
    @Input() pdfName: string = '';
    @Input() currentPage: number = 1;
    @Input() totalPages: number = 0;
    @Output() pageChange = new EventEmitter<number>();

    public activeTab: string = 'document';

    public tabs = [
        { id: 'document', label: '문서', icon: 'fa-regular fa-file-pdf' },
        { id: 'text', label: '텍스트', icon: 'fa-solid fa-align-left' },
        { id: 'images', label: '이미지', icon: 'fa-regular fa-images' },
        { id: 'kg', label: 'KG', icon: 'fa-solid fa-diagram-project' },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public ngOnChanges(changes: SimpleChanges) {
        // currentPage 변경 시 자식 컴포넌트에 전파됨 (Angular 바인딩)
    }

    public switchTab(tabId: string) {
        this.activeTab = tabId;
        this.service.render();
    }

    public onPageChange(page: number) {
        this.pageChange.emit(page);
    }
}

export default PortalNrichCanvasPanelComponent;